import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3491">
      <Navbar data-id="element-3492" />
      <main data-id="element-3493">
        <ConsularAffairs data-id="element-3494" />
      </main>
      <Footer data-id="element-3495" />
    </div>;
}